import { createFileRoute, redirect } from '@tanstack/react-router'

import {
  isAuthUserAuthenticated,
  isUserCloudWorker,
} from '@/stores/authUser.store'
import { getLastActiveMode, getLastPathForMode } from '@/stores/userMode.store'
import { parsePathAndSearch } from '@/utils/appMode'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (isAuthUserAuthenticated()) {
      const mode = isUserCloudWorker() ? 'work' : getLastActiveMode()
      const { pathname, search } = parsePathAndSearch(getLastPathForMode(mode))

      throw redirect({
        to: pathname,
        search,
      })
    }

    throw redirect({
      to: '/login',
    })
  },
})
